import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { useEventBus } from "hooks/useEventBus";

import { DEFAULT_VALUES } from "./PageMetadata.constants";

export const PageMetadata = () => {
  const [pageMeta] = useEventBus(EventBusTopic.Shell.PageMeta);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{pageMeta?.title || DEFAULT_VALUES.title}</title>
        {(pageMeta?.meta || DEFAULT_VALUES.meta || []).map((metaProps, idx) => (
          <meta key={`meta${idx}`} {...metaProps} />
        ))}
        {(pageMeta?.link || []).map((linkProps, idx) => (
          <link key={`link${idx}`} {...linkProps} />
        ))}
      </Helmet>
    </HelmetProvider>
  );
};
